import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row, Modal, ModalHeader, ModalBody, Spinner } from "reactstrap"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"
import { AvForm, AvField } from "availity-reactstrap-validation"

const TAB = { VA: 1, VD: 2, PA: 3, PD: 4 }
const TAB_LABELS = {
  1: "Vendor Addition Categories",
  2: "Vendor Deduction Categories",
  3: "Producer Addition Categories",
  4: "Producer Deduction Categories"
}

const API_MAP = {
  [TAB.VA]: { list: "vendor-addition-categories", create: "create-vendor-addition-category", delete: "delete-vendor-addition-category/" },
  [TAB.VD]: { list: "vendor-deduction-categories", create: "create-vendor-deduction-category", delete: "delete-vendor-deduction-category/" },
  [TAB.PA]: { list: "producer-addition-categories", create: "create-producer-addition-category", delete: "delete-producer-addition-category/" },
  [TAB.PD]: { list: "producer-deduction-categories", create: "create-producer-deduction-category", delete: "delete-producer-deduction-category/" },
}

const AdditionsDeductions = () => {
  const { canAdd, canDelete, MODULE } = usePermissions()
  const MID = MODULE.VEHICLES || 12
  const [tab, setTab] = useState(TAB.VA)
  const [data, setData] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [deleteId, setDeleteId] = useState("")
  const [search, setSearch] = useState("")
  const [showFilter, setShowFilter] = useState(false)
  const [addModal, setAddModal] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)

  const config = API_MAP[tab]

  const fetchData = useCallback(async () => {
    setDataLoaded(false); setCheckedItems({}); setParentChecked(false)
    try {
      const resp = await api.get(config.list)
      const arr = resp.data.data
      setData(Array.isArray(arr) ? arr : arr?.data || [])
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [tab])

  useEffect(() => { fetchData() }, [fetchData])

  const handleDelete = async () => {
    try { await api.delete(config.delete + deleteId); fetchData() } catch (e) { console.error(e) }
  }

  const handleCheckbox = id => {
    setCheckedItems(prev => {
      const n = { ...prev, [id]: !prev[id] }
      setParentChecked(data.length > 0 && data.every(p => n[p.id]))
      return n
    })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n)
    const items = {}; data.forEach(p => { items[p.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length
  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try {
      await Promise.all(ids.map(id => api.delete(config.delete + id)))
      setCheckedItems({}); setParentChecked(false); fetchData()
    } catch (e) { console.error(e) }
  }

  const filtered = useMemo(() => {
    if (!search) return data
    const s = search.toLowerCase()
    return data.filter(d => (d.categoryName || "").toLowerCase().includes(s) || (d.categoryType || "").toLowerCase().includes(s))
  }, [data, search])

  const switchTab = t => { setTab(t); setSearch(""); setShowFilter(false) }

  const actionBtnStyle = bg => ({
    width: "28px", height: "28px", borderRadius: "4px", background: bg, color: "#fff",
    border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer"
  })

  const isDeduction = tab === TAB.VD || tab === TAB.PD
  const colSpan = isDeduction ? 5 : 4

  const handleSubmit = async (e, v) => {
    setModalLoading(true)
    try {
      await api.post(config.create, v)
      setAddModal(false); fetchData()
    } catch (err) { console.error(err) }
    setModalLoading(false)
  }

  const typeColor = t => {
    if (t === "loan") return { bg: "#dc354515", fg: "#dc3545" }
    if (t === "advance") return { bg: "#0ea5e915", fg: "#0ea5e9" }
    return { bg: "#f59e0b15", fg: "#f59e0b" }
  }

  const summaryCards = [
    { label: `Total ${TAB_LABELS[tab]}`, value: data.length, icon: isDeduction ? "fa-minus-circle" : "fa-plus-circle", color: isDeduction ? "#dc3545" : "#22c55e" },
  ]

  return (
    <>
      {/* Tab Switcher */}
      <div className="incentivePanel">
        {Object.entries(TAB_LABELS).map(([k, label]) => (
          <span key={k} onClick={() => switchTab(Number(k))}
            className={tab === Number(k) ? "acActive" : ""}
            style={{ cursor: "pointer" }}>{label}</span>
        ))}
      </div>

      <div className="dashBody" style={{ marginTop: "10px" }}>
        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 style={{ margin: 0 }}>{TAB_LABELS[tab]}</h4>
            {canAdd(MID) && (
              <button title={`Add New`} onClick={() => setAddModal(true)}
                style={{ ...actionBtnStyle("#28a745"), width: "32px", height: "32px", fontSize: "14px" }}>
                <i className="fas fa-plus"></i>
              </button>
            )}
            {canDelete(MID) && (
              <button title={selectedCount > 0 ? `Delete ${selectedCount} selected` : "Select items to delete"}
                onClick={() => { if (selectedCount > 0) { handleMultiDelete(); setsuccess_dlg(true) } else alert("Select items first.") }}
                style={{ ...actionBtnStyle("#dc3545"), width: "32px", height: "32px", fontSize: "14px", opacity: selectedCount > 0 ? 1 : 0.7 }}>
                <i className="fas fa-trash"></i>
              </button>
            )}
            <button title="Toggle Filter" onClick={() => setShowFilter(!showFilter)}
              style={{ ...actionBtnStyle("#0d6efd"), width: "32px", height: "32px", fontSize: "14px" }}>
              <i className="fas fa-filter"></i>
            </button>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input type="text" className="form-control form-control-sm" placeholder="Search"
              style={{ width: "180px", borderRadius: "4px 0 0 4px" }}
              value={search} onChange={e => setSearch(e.target.value)} />
            <button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: "31px" }}>
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        <Row className="mb-3 mt-2">
          {summaryCards.map((card, i) => (
            <Col md={3} sm={6} key={i}>
              <div style={{
                background: "#fff", borderRadius: "10px", padding: "14px 16px",
                borderLeft: `4px solid ${card.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px"
              }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: card.color + "15",
                  display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={`fas ${card.icon}`} style={{ color: card.color, fontSize: "16px" }}></i>
                </div>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>{card.value}</div>
                  <div style={{ fontSize: "11px", color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.5px" }}>{card.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>#</th>
                {isDeduction && <th>Category Type</th>}
                <th>Category Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  {isDeduction && <td></td>}
                  <td><input type="text" className="form-control form-control-sm" placeholder="Filter..." value={search} onChange={e => setSearch(e.target.value)} /></td>
                  <td></td>
                </tr>
              )}
              {dataLoaded ? (
                filtered.length > 0 ? filtered.map((d, i) => {
                  const tc = typeColor(d.categoryType)
                  return (
                    <tr key={d.id}>
                      <td><input type="checkbox" checked={!!checkedItems[d.id]} onChange={() => handleCheckbox(d.id)} /></td>
                      <td>{i + 1}</td>
                      {isDeduction && (
                        <td>
                          <span style={{ background: tc.bg, color: tc.fg, padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 600, textTransform: "capitalize" }}>
                            {d.categoryType}
                          </span>
                        </td>
                      )}
                      <td style={{ fontWeight: 600 }}>{d.categoryName}</td>
                      <td>
                        <div style={{ display: "flex", gap: "3px" }}>
                          {canDelete(MID) && (
                            <button title="Delete" onClick={() => { setDeleteId(d.id); setconfirm_alert(true) }} style={actionBtnStyle("#dc3545")}>
                              <i className="fas fa-trash-alt"></i>
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                }) : (
                  <tr><td colSpan={colSpan} className="text-center py-4">
                    <i className={`fas ${isDeduction ? "fa-minus-circle" : "fa-plus-circle"} fa-2x text-muted mb-2 d-block`}></i>No records found
                  </td></tr>
                )
              ) : (
                <tr><td colSpan={colSpan}><img className="loaderImg" src={loader} alt="loading" /></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* ═══════ ADD MODALS ═══════ */}

      {/* Addition Category Modal (Vendor or Producer) */}
      {!isDeduction && (
        <Modal isOpen={addModal} toggle={() => setAddModal(false)} size="md">
          <ModalHeader toggle={() => setAddModal(false)}>
            {TAB_LABELS[tab]} <span style={{ color: "#dc3545", fontSize: "13px" }}>[* required]</span>
          </ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={handleSubmit}>
              <div className="mb-3">
                <AvField name="categoryName" label={`Client ${tab === TAB.VA ? "Vendor" : "Producer"} Addition Category Name *`} type="text" required />
              </div>
              <div className="text-end" style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                <button className="btn btn-success" type="submit" disabled={modalLoading}>
                  {modalLoading ? <Spinner size="sm" /> : "Save Changes"}
                </button>
                <button className="btn btn-danger" type="button" onClick={() => setAddModal(false)}>Close</button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      )}

      {/* Deduction Category Modal (Vendor or Producer) */}
      {isDeduction && (
        <Modal isOpen={addModal} toggle={() => setAddModal(false)} size="md">
          <ModalHeader toggle={() => setAddModal(false)}>
            {TAB_LABELS[tab]} <span style={{ color: "#dc3545", fontSize: "13px" }}>[* required]</span>
          </ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="categoryType" label={`Client ${tab === TAB.VD ? "Vendor" : "Producer"} Advance Category Type *`} required>
                      <option value="">Select</option>
                      <option value="loan">Loan</option>
                      <option value="advance">Advance</option>
                      <option value="recovery">Recovery</option>
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField name="categoryName" label={`Client ${tab === TAB.VD ? "Vendor" : "Producer"} Advance Category Name *`} type="text" required />
                  </div>
                </Col>
              </Row>
              <div className="text-end" style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                <button className="btn btn-success" type="submit" disabled={modalLoading}>
                  {modalLoading ? <Spinner size="sm" /> : "Save Changes"}
                </button>
                <button className="btn btn-danger" type="button" onClick={() => setAddModal(false)}>Close</button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      )}

      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true) }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title="Deleted" onConfirm={() => setsuccess_dlg(false)}>Record deleted successfully.</SweetAlert>
      )}
    </>
  )
}

export default AdditionsDeductions
